import React from "react";
import styles from "./status-chip.module.css";
import { capitalizeFirstLetter } from "../../utils/format-text/fomat-text";

const statusMap = {
  active: {
    backgroundColor: "#ECFDF3",
    color: "#027A48",
    progressColor: "#4CAF50",
  },
  inactive: {
    backgroundColor: "#FEE4E2",
    color: "#D92D20",
    progressColor: "#FF5722",
  },
  completed: {
    backgroundColor: "#ECF8ED",
    color: "#3BB44B",
    progressColor: "#3BB44B",
  },
  ongoing: {
    backgroundColor: "#F0F8FF",
    color: "#1E9EFD",
    progressColor: "#1E9EFD",
  },
  upcoming: {
    backgroundColor: "#FFFEE4",
    color: "#F0AF00",
    progressColor: "#F0AF00",
  },

  approved: {
    backgroundColor: "#ECF8ED",
    color: "#3BB44B",
    progressColor: "#3BB44B",
  },
  rejected: {
    backgroundColor: "#FCEEED",
    color: "#E05A21",
    progressColor: "#E05A21",
  },
  "action required": {
    backgroundColor: "#FFFEE4",
    color: "#F0AF00",
    progressColor: "#F0AF00",
  },
};

const StatusChip = ({ status }) => {
  const lowerCaseStatus = status?.toLowerCase();

  const normalizedStatusMap = Object.keys(statusMap).reduce((acc, key) => {
    acc[key.toLowerCase()] = statusMap[key];
    return acc;
  }, {});

  const { backgroundColor, color } = normalizedStatusMap[lowerCaseStatus];

  return (
    <div className={styles.statusChip} style={{ backgroundColor, color }}>
      <div className={styles.badgeIcon} style={{ backgroundColor: color }} />
      {capitalizeFirstLetter(lowerCaseStatus)}
    </div>
  );
};

export default StatusChip;
